import { Injectable } from '@angular/core';

import { CarriedItem, PlanEditGesture } from '@core/models/plan-edit-gesture.model';

import { AnchoredPopupState } from '@shared/services/anchored-popup/anchored-popup-state';

export interface SetTimeRequest {
  kind: 'set-time';
  routeUid: string;
  actionUid: string;
  /** The block's name, as the form's title calls the stop. */
  stopName: string;
  /** The stop's pin origin, as an ISO instant. */
  current: string;
  siteTimeZone: string;
}

export interface RouteStartRequest {
  kind: 'route-start';
  routeUid: string;
  /** The route's name, as the form's title calls it. */
  routeName: string;
  /** The route's start leg's scheduled start, as an ISO instant. */
  current: string;
  /** The zone of the start leg's site. */
  siteTimeZone: string;
}

export interface MoveToRequest {
  kind: 'move-to';
  carried: CarriedItem;
  /** What the form's title calls the carried item: a stop's name, a job's uid, a tour's number. */
  name: string;
  /** The carried tour is a one-tour route's every stop, and `name` the route's. */
  allStops?: boolean;
}

export type PlanEditFormRequest =
  | SetTimeRequest
  | RouteStartRequest
  | MoveToRequest
  | { kind: 'resources'; routeUid: string }
  | { kind: 'new-route'; then: PlanEditGesture | null; carriedName?: string }
  | { kind: 'swap'; routeUid: string; otherRouteUid: string | null };

/** The one plan edit form open at a time, anchored to the block or label it acts on. */
@Injectable({ providedIn: 'root' })
export class PlanEditFormsService extends AnchoredPopupState<PlanEditFormRequest> {}
